/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC } from 'react';
import { PaginationProps, Table as AntTable, Pagination } from 'antd';
import { TableProps as AntTableProps } from 'antd/lib';
import './table.scss';

interface TableProps extends AntTableProps {
    columns: object[];
    data: object[];
    pagination: {
        currentPage: number;
        total: number;
        pageSize: number;
        onChange: (page: number) => void;
    };
    paginationSize?: number;
}

const Table: FC<TableProps> = ({ columns, data, paginationSize = 20, pagination, ...props }) => {

    const handlePaginationChange = (page: number) => {
        pagination.onChange(page);
    };

    const handleTotal = (total: number, range: [number, number]): JSX.Element => (
        <div style={{ left: 0, position: 'absolute' }}>
            Result: <span style={{ color: '#EF233C' }}>{range[0].toLocaleString()} - {range[1].toLocaleString()} of {pagination.total.toLocaleString()}</span>
        </div>
    );

    const itemRender: PaginationProps['itemRender'] = (page, type, originalElement) => {
        const lastPage = Math.ceil(pagination.total / pagination.pageSize);
        if (type === 'page') {
            return page === pagination.currentPage ? <div className="request-table-pagination">Page <span style={{ color: '#EF233C' }}>{page}</span> of {lastPage}</div> : null;
        }
        return originalElement;
    };

    return (
        <div className="table-container">
            <div className="table-scroll-wrapper">
                <AntTable
                    {...props}
                    dataSource={data}
                    columns={columns}
                    pagination={false} />
            </div>
            <Pagination
                current={pagination.currentPage}
                pageSize={pagination.pageSize}
                total={pagination.total}
                onChange={handlePaginationChange}
                showTotal={handleTotal}
                itemRender={itemRender}
                showSizeChanger={false} />
        </div>
    );
};

Table.defaultProps = {
    paginationSize: 20,
};

export default Table;
